import './Login.css';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../services/firebase';

export default function Signup({ onDone, onGoLogin }) {
  const { t } = useTranslation();
  const [accountName, setAccountName] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (!accountName.trim() || !email.trim() || !password) return;
    if (password.length < 6) { setError(t('auth.errors.passwordTooShort')); return; }
    if (password !== confirmPassword) { setError(t('auth.errors.passwordMismatch')); return; }
    setError('');
    setLoading(true);
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      const provisionAccount = httpsCallable(functions, 'provisionAccount');
      await provisionAccount({ accountName, name });
      await onDone();
    } catch (err) {
      console.error(err);
      setError(t('auth.errors.signup'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-brand">
          <svg viewBox="0 0 32 32" aria-hidden="true">
            <rect width="32" height="32" rx="8" fill="#16C47F" />
            <path d="M8 8h16a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6l-5 4v-4H8a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" fill="#07241A" />
          </svg>
          Yunoo <span className="login-chip">ADMIN</span>
        </div>
        <h2>{t('auth.signupTitle')}</h2>
        <p className="login-sub">{t('auth.signupSubtitle')}</p>
        <input className="field" placeholder={t('auth.businessName')} value={accountName} onChange={e => setAccountName(e.target.value)} />
        <input className="field" placeholder={t('auth.yourName')} value={name} onChange={e => setName(e.target.value)} />
        <input className="field" type="email" placeholder={t('auth.email')} value={email} onChange={e => setEmail(e.target.value)} />
        <input className="field" type="password" placeholder={t('auth.passwordHint')} value={password} onChange={e => setPassword(e.target.value)} />
        <input className="field" type="password" placeholder={t('auth.confirmPassword')} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && submit()} />
        {error && <p className="login-error">{error}</p>}
        <button className="btn btn-primary login-submit" onClick={submit} disabled={loading}>
          {loading ? t('auth.creating') : t('auth.createAccount')}
        </button>
        <p className="login-alt">
          {t('auth.haveAccount')} <button type="button" onClick={onGoLogin}>{t('auth.signIn')}</button>
        </p>
      </div>
    </div>
  );
}
